<div class="alert alert-danger ng-star-inserted credit-hold-alert my-3">
  <span class="alert-icon"><cx-icon class="cx-icon fas fa-exclamation-circle"></cx-icon></span>
  <span class="credit-hold-alert-text">{{ 'creditHold.message' | cxTranslate }}</span>
</div>
